import { CachingContainerComponent } from "@/lib/caching/container/component"
import { consumeLoading } from "@/lib/consume/loading"

export const CachingContainerConsumer = consumeLoading(
  CachingContainerComponent
)
